import React, {Component} from "react";
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import FormInputField from './FormInputField';

import * as actions from '../../actions';

class SwitchButton extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const {name, checked} = event.target;
        const [articleName, field] = name.split('.');
        this.props.changeData(field, checked === true ? 1 : 0, articleName, this.props.articleID)
            .then((currentState) => {
                this.props.isFormValid();
                let article = articleName.toLowerCase();
                return this.props.fetchImage(currentState[article], article, this.props.articleID)
            });
    }

    render() {
        return (
            <div className={`switch-wrapper ${this.props.divClass}`}>
                <div className="switch">
                    <label>
                        <span className="form-input">
                            {this.props.labelPosition !== "left" ? this.props.labelName : null}
                        </span>
                        <input type="checkbox"
                            name={this.props.name}
                            value={this.props.value}
                            checked={this.props.value === 1 ? true : false}
                            onChange={this.handleChange}
                        />
                        <span className="lever">&nbsp;</span>
                        <span className="form-input">
                            {this.props.labelPosition === "left" ? this.props.labelName : null}
                        </span>
                    </label>
                </div>
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
SwitchButton.propTypes = {
    switchButton:   PropTypes.bool,
    labelName:      PropTypes.string.isRequired,
    labelPosition:  PropTypes.string.isRequired,
    onSwitchChange: PropTypes.func.isRequired,
    divClass:       PropTypes.string,
    changeData:     PropTypes.func.isRequired,
    isFormValid:      PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        bathtub: state.bathtub,
    }
}

export default connect(mapStateToProps, actions)(SwitchButton);



// WEBPACK FOOTER //
// ./src/components/forms/SwitchButton.js